import { createSlice } from '@reduxjs/toolkit';

const exportSlice = createSlice({
  name: 'export',
  initialState: {
    isExporting: false,
  },
  reducers: {
    setExporting: (state, action) => {
      state.isExporting = action.payload;
    },
  },
});

export const { setExporting } = exportSlice.actions;
export default exportSlice.reducer;